export default __webpack_public_path__ + "static/media/tweet_sa.548f0e27.webp";